import SetMinRestingTimeModal from './set-min-resting-time-modal.vue'
export default SetMinRestingTimeModal
